var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"childbox1 relative",attrs:{"id":"app"}},[_c('div',{staticClass:"chart_box3 dn-content-bg"},[_c('div',{staticClass:"top"},[_vm._v(_vm._s(_vm.pie.titleTime))]),_c('div',{ref:"tapp",staticClass:"box dn-content-bg",attrs:{"id":_vm.echartsId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }